var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fit-bounds-control"},[_c('b-button',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.fitAll}},[_vm._v("Fit map")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }